import clsx from "clsx";
import React from "react";
import { Box, BoxProps, Divider, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  divider: {
    height: 1,
    width: 300,
    backgroundColor: theme.palette.divider,
  },

  text: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: "20px",
    padding: theme.spacing(0, 2),
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
    position: "absolute",
  },
}));

export interface OrDividerProps extends BoxProps {
  textClassName?: string;
}

export function OrDivider(props: OrDividerProps) {
  const { className, textClassName, ...other } = props;
  const s = useStyles();

  return (
    <Box className={clsx(s.root, className)} {...other}>
      <Divider className={s.divider} />
      <Typography className={clsx(s.text, textClassName)} children="or" />
    </Box>
  );
}
